import { SidebarResourceKind } from 'types'

/**
 * A document or table renamed or archived from outside its own page (the sidebar's row menu), so a
 * page that has it open can follow without fetching it again. A page's own edits don't come through
 * here: it has already applied them.
 */
export type ResourceChange = { kind: SidebarResourceKind; id: string } & (
  | { change: 'renamed'; name: string }
  | { change: 'archived' }
)

type ResourceChangeListener = (change: ResourceChange) => void

const listeners = new Set<ResourceChangeListener>()

/**
 * Calls `listener` with every change to the document or table `id` published from now on, until the
 * returned function is called. For a useEffect to return.
 */
export const subscribeResourceChanges = (
  kind: SidebarResourceKind,
  id: string,
  listener: ResourceChangeListener
): (() => void) => {
  const forThis: ResourceChangeListener = (change) => {
    if (change.kind === kind && change.id === id) listener(change)
  }
  listeners.add(forThis)
  return () => {
    listeners.delete(forThis)
  }
}

export const publishResourceChange = (change: ResourceChange): void => {
  for (const listener of [...listeners]) listener(change)
}
